module.exports = __webpack_public_path__ + "img/titleimg2.46a58af4.png";